const translations = {
  cta: "Activate your free benefit"
};

export default translations;
